/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha29 = props => (
<svg version={1.0} width="128" height="128" viewBox="0 0 128 128" {...props}>
  <defs>
    <mask id="hole">
      <rect width="100%" height="100%" fill="white"/>
      <circle cx="65" cy="62" r="37" fill="black"/>
    </mask>
  </defs>

  <g id="watch">
    <path mask="url(#hole)" d="M 38 8.5 L 45.5 8.5 L 45.5 16 L 87 16 L 87 9 L 93 9 L 112 54 L 104 90 L 95 119.5 L 85 119.5 L 85 104 L 41.6 104 L 41.6 119.5 L 33.2 119.5 L 17 65.7 L 26 32.2 z" />
    <circle cx="65" cy="62" r="51" mask="url(#hole)"/>
    <rect x="63" y="31" width="5" height="31" rx="5" ry="5" />
    <rect x="94" y="5" width="20" height="5" rx="5" ry="5" transform="rotate(40)" />
  </g>
</svg>
);
export default extendIcon(Deha29);
